import { knowledgeBaseSectionPath } from '../knowledge-base/sections';
import { useKbReadiness } from '../knowledge-base/useKbReadiness';
import { useBrandCopy } from '../onboarding/useBrandCopy';
import { PanelLink } from './PanelLink';
import { pickReadinessGap, READINESS_SECTIONS } from './readinessRows';

/**
 * Brand-profile readiness as one line on Home: the score and the same nudge
 * the full card shows. Setup that is finished is not the news, so the line is gone
 * at 100 — and while it loads or if it fails, since it is a hint, not a gate.
 * The full eleven-row card lives on the brand profile page.
 */
export function ReadinessLine({ businessId }: { businessId: string }) {
  const { readiness } = useKbReadiness(businessId);
  const copy = useBrandCopy();
  if (readiness === null || readiness.score >= 100) return null;

  const gap = pickReadinessGap(readiness.items);
  const spec = gap ? copy.readiness[gap.key] : null;

  return (
    <aside className="home-readiness" aria-label="Profile strength">
      <span className="home-readiness__label">Profile strength</span>
      <span className="home-readiness__score">{readiness.score}</span>
      {gap && spec ? (
        <span className="home-readiness__nudge">
          {spec.nudge}{' '}
          <PanelLink to={knowledgeBaseSectionPath(READINESS_SECTIONS[gap.key])}>
            Open {spec.label.toLowerCase()}
          </PanelLink>
        </span>
      ) : null}
    </aside>
  );
}
